module.exports = __webpack_public_path__ + "img/coming-soon_th.afa82be.jpg";